import {useCallback, useEffect, useRef, useState} from 'react'

const getLineHeight = () => (window.innerWidth > 360 ? 19 : 38)

const useTextAreaHeight = (error?: string) => {
  const errorRef = useRef({
    error: false,
    heightDeducted: false,
  })
  const getHeight = useCallback(() => {
    errorRef.current = {heightDeducted: !!error, error: !!error}
    const extraHeight = error ? getLineHeight() : 0
    if (window.visualViewport && window.innerWidth < 768)
      return window.visualViewport.height - 250 - extraHeight
    return window.innerWidth > 768
      ? 242
      : window.innerHeight - 250 - extraHeight
  }, [error])

  const [height, setHeight] = useState<number>(() => getHeight())

  useEffect(() => {
    if (error) {
      if (errorRef.current.heightDeducted) return
      setHeight(prevState => prevState - getLineHeight())
      errorRef.current = {
        ...errorRef.current,
        error: true,
      }
    } else if (!error && errorRef.current.error) {
      setHeight(prevState => prevState + getLineHeight())
    }
    errorRef.current = {heightDeducted: false, error: !!error}
  }, [error])

  useEffect(() => {
    const handleResize = () => {
      setHeight(getHeight())
    }

    window.addEventListener('resize', handleResize)
    // From the top of my head this used to be required for older browsers since
    // this didn't trigger a resize event. Keeping it in to be safe.
    window.addEventListener('orientationchange', handleResize)
    // This is needed on iOS to resize the viewport when the Virtual/OnScreen
    // Keyboard opens. This does not trigger any other event, or the standard
    // resize event.
    window.visualViewport?.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
      window.visualViewport?.removeEventListener('resize', handleResize)
    }
  }, [getHeight])

  return height
}

export default useTextAreaHeight
